<template>
    <div>
        <div class="text-center" v-if="loading">
            <loading/>
        </div>
        <form
                @submit.prevent="saveData()"
                class="titan-form titan-inline-form"
                v-if="!loading"
                novalidate
        >
            <vue-form-generator
                    ref="form"
                    :schema="schema"
                    :model="model"
                    :options="formOptions"
            />
            <button type="submit" class="btn btn-primary">
                <span>Zmeniť heslo</span>
            </button>
        </form>
    </div>
</template>

<script>
    import VueFormGenerator from "vue-form-generator";
    import Loading from "../Loading";
    import {validateForm} from "../../utils";

    export default {
        name: "ChangePassword",
        components: {
            Loading,
        },
        computed: {
            loading() {
                return this.$store.state.account.loading;
            }
        },
        methods: {
            saveData() {
                if (validateForm(this.$refs.form)) {
                    this.$store.dispatch("account/changePassword", this.model).then(() => {
                        this.$emit('changed');
                    });
                }
            }
        },
        data() {
            return {
                model: {
                    oldPassword: "",
                    newPassword: ""
                },
                schema: {
                    fields: [
                        {
                            type: "titanPassword",
                            label: "Staré heslo",
                            model: "oldPassword",
                            required: true,
                            validator: VueFormGenerator.validators.string
                        },
                        {
                            type: "titanPassword",
                            label: "Nové heslo",
                            model: "newPassword",
                            min: 6,
                            required: true,
                            validator: VueFormGenerator.validators.string
                        }
                    ]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true,
                    validateAsync: false
                }
            };
        }
    };
</script>

<style lang="scss" scoped>
    .button-row {
        margin-top: -10px;

        small {
            display: block;
            line-height: 120%;
        }
    }
</style>
